import { PhotoSets } from '../translations-types';

const translations: PhotoSets = {
  title: "Voor/na-foto's",
  portalTitle: "Mijn foto's",
  newSet: 'Nieuwe fotoset',
  noSets: "Nog geen fotosets. Maak een set met foto's van alle kanten.",
  noSharedSets: "Er zijn nog geen foto's met je gedeeld.",
  angleLeftProfile: 'Profiel links',
  angleLeft45: '45° links',
  angleFront: 'Voorkant',
  angleRight45: '45° rechts',
  angleRightProfile: 'Profiel rechts',
  labelBefore: 'Voor',
  labelAfter: 'Na',
  labelProgress: 'Tussenstand',
  noLabel: 'Geen label',
  pin: 'Vastpinnen om te vergelijken',
  unpin: 'Losmaken',
  pinnedTitle: 'Vastgepind',
  pinHint: 'Pin sets vast om ze bovenaan te houden en te vergelijken.',
  otherSets: 'Alle sets',
  compare: 'Vergelijken',
  sideBySide: 'Naast elkaar',
  slider: 'Schuifbalk',
  compareHint: 'Pin twee of meer sets vast om ze per hoek te vergelijken.',
  editSet: 'Set bewerken',
  deleteSet: 'Set verwijderen',
  deleteSetConfirm: "Weet je het zeker? De set en alle foto's worden verwijderd.",
  deletePhotoConfirm: 'Deze foto verwijderen?',
  date: 'Datum',
  appointment: 'Afspraak',
  noAppointment: 'Geen afspraak (vrije datum)',
  label: 'Label',
  notes: 'Notitie',
  sharedWithCustomer: 'Zichtbaar voor cliënt',
  sharedHint: 'De cliënt ziet deze set in het klantportaal.',
  sharedTag: 'Zichtbaar voor cliënt',
  notSharedTag: 'Alleen salon',
  shareConfirm: "Deze set delen met de cliënt? Hij verschijnt dan in 'Mijn foto's'.",
  unshareConfirm: 'Deze set niet meer tonen aan de cliënt?',
  swapSides: 'Wissel kant',
  saved: 'Opgeslagen',
  addPhotos: "Foto's maken",
  retake: 'Opnieuw maken',
  realign: 'Uitlijnen',
  removePhoto: 'Foto verwijderen',
  emptyAngle: 'Geen foto',
  captureTitle: "Foto's maken",
  capture: 'Vastleggen',
  uploadInstead: 'Foto uploaden',
  switchCamera: 'Camera wisselen',
  ghost: 'Vorige foto',
  next: 'Volgende',
  previous: 'Vorige',
  done: 'Klaar',
  uploading: 'Bezig met opslaan…',
  cameraError: 'Camera niet beschikbaar. Je kunt ook een foto uploaden.',
  guideLoading: 'Gezichtsherkenning laden…',
  guideFaceNotFound: 'Geen gezicht gevonden',
  guideCloser: 'Kom dichterbij',
  guideFurther: 'Iets verder weg',
  guideTurnMore: 'Draai het hoofd verder',
  guideTurnLess: 'Draai het hoofd iets terug',
  guideGood: 'Goed zo',
  alignTitle: 'Foto uitlijnen',
  zoom: 'Zoom',
  rotation: 'Draaien',
  reference: 'Vergelijk met',
  none: 'Geen',
  alignHint: 'Versleep en zoom de foto zodat het hoofd binnen de hulplijn valt.',
  autoAlign: 'Automatisch uitlijnen',
  autoAlignFailed: 'Geen gezicht gevonden; lijn de foto handmatig uit.',
  reset: 'Herstellen',
  alignedAuto: 'Automatisch uitgelijnd',
  alignedManual: 'Handmatig uitgelijnd',
  notAligned: 'Niet uitgelijnd',
  uploadError: 'Opslaan van de foto is mislukt.',
  photosCount: "{{count}} van 5 foto's",
  close: 'Sluiten',
};

export default translations;
